export default __webpack_public_path__ + "static/media/closeIcon.4ba54b67.svg";